import axios from 'axios';
import config from '../config';

const axiosInstance = axios.create({
  baseURL: config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL,
})

//👉 Interceptor de Respuesta
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
     
      const { status, data } = error.response
      let message

      switch (status) {
        case 400:
          message = data.message || 'Solicitud incorrecta.'
          break;
        case 401:
          message = data.message || 'No autorizado. Por favor, inicie sesión.'
          break;
        case 409:
          //console.log('axiosConfig recibiendo el error...', data.message)
          message = data.message || 'Conflicto en los datos enviados.'
          break;
        default:
          message = data.message || 'Ocurrió un error desconocido.'
      }

      //👉 se crea un nuevo tipo de error
      return Promise.reject({
        status, 
        message, 
      })
    }
    //👉 Se retorna el nuevo error para que lo capture registerService en el catch (postData)
    return Promise.reject(error)
  }
)

export default axiosInstance
